import ResetPassword from './ResetPassword.page';

export default ResetPassword;